import { Component } from '@angular/core';

@Component({
    selector: 'landing-business-blog-post',
    imports: [],
    templateUrl: './blog-post.component.html',
    styleUrl: './blog-post.component.scss'
})
export class LandingBusinessBlogPostComponent {

}
